export default __webpack_public_path__ + "static/media/copay-wallet.f670b3a8.svg";